import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isPlatformRequired = location.state?.reason === 'PLATFORM_ADMIN_REQUIRED';

  return (
    <div className="lis-error-page">
      <div className="lis-error-card" style={{ maxWidth: '560px' }}>
        <div className="lis-error-icon">&#128683;</div>
        <h1 className="lis-error-title">
          {isPlatformRequired ? '403 — SaaS Platform Admin Privileges Required' : '403 — Access Restricted'}
        </h1>
        <p className="lis-error-desc">
          {isPlatformRequired ? (
            <>
              This infrastructure area is strictly restricted to SaaS Platform Fleet Administrators.
              Your account is logged into tenant{' '}
              <strong style={{ color: '#0284c7' }}>{user?.tenantCode || 'Client Tenant'}</strong> with role{' '}
              <strong>{user?.roleName || 'Tenant Administrator'}</strong>. You have full authority over your laboratory's
              clinical masters, center staff, appointments, and billing under the main navigation.
            </>
          ) : (
            <>
              Your current user role (<strong>{user?.roleName || 'Current Role'}</strong>) does not have authorization
              to access this clinical module or administrative action.
            </>
          )}
        </p>
        <div className="lis-error-actions" style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
          <button onClick={() => navigate('/dashboard')} className="lis-btn lis-btn-primary">
            Return to Dashboard
          </button>
          {isPlatformRequired && (
            <button onClick={() => navigate('/employees')} className="lis-btn lis-btn-secondary">
              Manage Tenant Employees
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
